<template>
  <div id="approve_order">
    <!-- 顶部导航栏 -->
    <van-nav-bar :title="$t('title.approve')" placeholder safe-area-inset-top @click-left="onClickLeft" left-arrow />
    <van-col span="24" class="approve_order_bottom"  v-if="isLocalCurrencyShow">
       <!-- 提现成功标题和金额  === '0'-->
        <van-col span="24" class="withdraw-success-header">
          <van-col span="24" class="withdraw-amount">${{ orderData.dollar_amount }}</van-col>
          <van-col span="24" :class="orderData.result_status == 0 ? 'withdraw-wait-text' : orderData.result_status == 1 ? 'withdraw-success-text' : 'withdraw-success-text'"> {{ orderData.result_text }}</van-col>
        </van-col>

        <!-- 详细信息卡片 -->
        <van-col span="22" offset="1" class="withdraw-info-card">
          <van-col span="24" class="info-row">
            <van-col span="12" class="info-label">{{ $t('column.Platform_id') }}:</van-col>
            <van-col span="12" class="info-value">{{ orderData.user_id }}</van-col>
          </van-col>
          <van-col span="24" class="info-row">
            <van-col span="12" class="info-label">{{ $t('column.amount_details') }}:</van-col>
            <van-col span="12" class="info-value">${{ orderData.dollar_amount }} = <img src="../assets/img/coin9.png" class="info-value-img"/>{{ orderData.bean_amount }}</van-col>
          </van-col>
          <van-col span="24" class="info-row"  v-if="orderData.user_currency_code">
            <van-col span="12" class="info-label">{{ $t('column.local_currency') }}:</van-col>
            <van-col span="12" class="info-value">
              <img :src="orderData.user_country_img" class="info-value-img" v-if="orderData.user_country_img"/>
              <span> {{ orderData.user_currency_code }} {{ orderData.user_local_amount }}</span>
            </van-col>
          </van-col>
          <van-col span="24" class="info-row">
            <van-col span="12" class="info-label">{{ $t('column.actual_amount_received') }}:</van-col>
            <van-col span="12" class="info-value">
              <span v-if="orderData.user_currency_code">{{ orderData.user_currency_code }} {{ orderData.user_local_amount }}</span>
              <span v-else>${{ orderData.dollar_amount }}</span>
             </van-col>
          </van-col>
        </van-col>

        <!-- 支付方式和钱包地址卡片 -->
        <van-col span="22" offset="1" class="withdraw-info-card">
          <van-col span="24" class="info-row">
            <van-col span="12" class="info-label">{{ $t('column.payment_method') }}:</van-col>
            <van-col span="12" class="info-value">
              <img :src="orderData.payment_method_img" class="payment-icon" /> {{ orderData.payment_method_name }}
            </van-col>
          </van-col>
          <van-col span="24" class="info-row" v-for="(t,i) in orderData.account_json" :key="i">
            <van-col span="12" class="info-label">{{ t.name }}</van-col>
            <van-col span="12" class="info-value address-value">
              <span  :id="'bkash_id' + i">{{ t.value }}</span>
              <img src="../assets/img/creator/creator_agency_fz.png" @click="copyId('bkash_id' + i)" />
            </van-col>
          </van-col>
        </van-col>
        <!-- 订单信息卡片 -->
        <van-col span="22" offset="1" class="withdraw-info-card">
          <van-col span="24" class="info-row">
            <van-col span="8" class="info-label">{{ $t('column.order_number') }}:</van-col>
            <van-col span="16" class="info-value">
              <span :id="'order_id' + orderData.order_id">{{ orderData.order_id }}</span>
               <img src="../assets/img/creator/creator_agency_fz.png" @click="copyId('order_id' + orderData.order_id)" />

            </van-col>
          </van-col>
          <van-col span="24" class="info-row">
            <van-col span="12" class="info-label">{{ $t('column.order_time') }}:</van-col>
            <van-col span="12" class="info-value">{{ orderData.create_time }}</van-col>
          </van-col>
          <van-col span="24" class="info-row">
            <van-col span="12" class="info-label">{{ $t('column.payment_time') }}:</van-col>
            <van-col span="12" class="info-value">{{ orderData.process_time }}</van-col>
          </van-col>
        </van-col>
        
          <!-- 支付凭证 -->
          <van-col span="22" offset="1" class="approve_order_bg_proof">
            <van-col span="22" offset="1" class="approve_order_bg_proof_title">{{ $t('column.payment_proof')}}</van-col>
            <van-col span="22" offset="1">
              <uploadImage
                  ref="uploader"
                  class="approve_order_bg_proof_upload"
                  :imageUrl="proof_img"
                  :cos-config="cosConfig"
                  v-if="iscos"
                  @successUploadImage="handleSuccess"
                  @errorUploadImage="handleError"
              />
            </van-col>
          </van-col>
          <!-- 倒计时提醒 -->
          <van-col span="22" offset="1" v-if="countdown_time">
            <van-col span="22" offset="1" class="approve_order_bg_content">
              <van-count-down :time="countdown_time" style="display: inline-block; color: #FF6666; vertical-align: baseline;" />
              <span style="margin-left: 2px;">{{ $t('column.please_finish_payment_before_countdown') }}</span>
            </van-col>
          </van-col>
    </van-col>
    <van-col span="24" v-else>
      <!-- 订单状态 -->
        <van-col span="22" offset="1" class="approve_order_status">
          <van-tag type="warning" round  :color="shouldShowColor(orderData.status)">
            <img src="../assets/img/approve_order_status.png" v-if="orderData.status ==='0'"/>
            <img src="../assets/img/approve_order_status1.png" v-else-if="orderData.status ==='1'"/>
            <img src="../assets/img/approve_order_status3.png" v-else-if="orderData.status ==='3'"/>
            <img src="../assets/img/approve_order_status4.png" v-else/>
            {{ orderData.status_text }}
          </van-tag>
    <!--      <span class="approve_order_status_div"><img src="../assets/img/approve_order_status.png"/> {{ orderData.status_text }} 00</span>-->
        </van-col>
        <!-- 支付金额信息 -->
        <van-col span="22" offset="1">
          <van-col span="24" class="approve_order_payment_label">{{ $t('column.payment_amount')}}</van-col>
          <van-col span="18" class="approve_order_payment_money">
            {{ orderData.currency_type_code }}  <span id="payment_amount">{{ orderData.cash_amount }}</span> <img src="../assets/img/creator/creator_agency_fz.png" @click="copyId('payment_amount')" />
          </van-col>
          <van-col span="6" class="approve_order_payment_img">
            <img :src="orderData.payment_method_img"/>
          </van-col>
          <van-col span="24" class="approve_order_id">{{ $t('column.order_id') }}:  <span id="creator_user_id">{{ orderData.order_id }}</span> <img src="../assets/img/creator/creator_agency_fz.png" @click="copyId('creator_user_id')" /></van-col>
          <van-col span="24" class="approve_order_create_time">{{ $t('column.order_create_time')}}: {{ orderData.create_time }}</van-col>
        </van-col>

        <van-col span="24" class="approve_order_bg">
          <!-- 倒计时提醒 -->
          <van-col span="22" offset="1" class="approve_order_bg_time" v-if="countdown_time">
            <van-col span="24" class="approve_order_bg_time_icon">
              <van-icon name="clock" color="#ffffff" size="20" /> <van-count-down :time="countdown_time" />
            </van-col>
            <van-col span="22" offset="1" class="approve_order_bg_content"> {{ $t('column.please_finish_payment_before_countdown') }} </van-col>
          </van-col>
            <!--   详细信息     -->
          <van-col span="22" offset="1" class="approve_order_bg_bean">
            <van-col span="22" offset="1" class="approve_order_bg_bean_title">{{ ticket_name }} {{ $t('column.details')}}</van-col>
            <van-col span="22" offset="1" class="approve_order_bg_bean_rewards">
               <van-col span="8" class="approve_order_bg_bean_rewards_item">
                <van-col span="24" class="approve_order_bg_bean_rewards_item_label">{{ $t('column.total') }}</van-col>
                <van-col span="24" class="approve_order_bg_bean_rewards_item_value">
                  <img src="../assets/img/coin9.png"/> {{ orderData.total_amount }}
                </van-col>
              </van-col>
              <van-col span="8" class="approve_order_bg_bean_rewards_item">
                <van-col span="24" class="approve_order_bg_bean_rewards_item_label">{{ $t('other.profit')}}</van-col>
                <van-col span="24" class="approve_order_bg_bean_rewards_item_value">
                  <img src="../assets/img/coin9.png"/> {{ orderData.received_amount }}
                </van-col>
              </van-col>
              <van-col span="8" class="approve_order_bg_bean_rewards_item">
                <van-col span="24" class="approve_order_bg_bean_rewards_item_label">{{ $t('column.official_reward')}}</van-col>
                <van-col span="24" class="approve_order_bg_bean_rewards_item_value">
                  <img src="../assets/img/coin9.png"/> {{ orderData.official_amount }}
                </van-col>
              </van-col>
            </van-col>
          </van-col>
          <!-- 账户信息 -->
          <van-col span="22" offset="1" class="approve_order_bg_account">
            <van-col span="22" offset="1" v-for="(t,i) in orderData.account_json" :key="i">
              <van-col span="12" class="approve_order_bg_account_info_label">{{ t.name }}</van-col>
              <van-col span="12" class="approve_order_bg_account_info_value">
                <span :id="'bkash_id' + i">{{ t.value }}</span> <img src="../assets/img/creator/creator_agency_fz.png" @click="copyId('bkash_id' + i)" />
              </van-col>
            </van-col>
          </van-col>
          <!-- 支付凭证 -->
          <van-col span="22" offset="1" class="approve_order_bg_proof">
            <van-col span="22" offset="1" class="approve_order_bg_proof_title">{{ $t('column.payment_proof')}}</van-col>
            <van-col span="22" offset="1">
              <uploadImage
                  ref="uploader"
                  class="approve_order_bg_proof_upload"
                  :imageUrl="proof_img"
                  :cos-config="cosConfig"
                  v-if="iscos"
                  @successUploadImage="handleSuccess"
                  @errorUploadImage="handleError"
              />
            </van-col>
          </van-col>
        </van-col>
    </van-col>
    
    <van-action-sheet v-model="transferShow" :actions="actions" @select="onSelect" :cancel-text="$t('coin_dealer.cancel')"
  close-on-click-action />
    <!-- 底部操作按钮 onClickCancel -->
    <van-goods-action safe-area-inset-bottom	class="approve_order_goods_action">
      <van-goods-action-icon text="Cancel" @click="onClickTransfer">
        <template #icon>
          <van-col span="24" class="approve_order_goods_action_img">
            <img src="../assets/img/approve_order_proof_delete.png"/>
          </van-col>
        </template>
      </van-goods-action-icon>
      <van-goods-action-button
          type="danger"
          color="#FF61F5"
          text="Confirmation of payment"
          @click="onClickButton"
      />
    </van-goods-action>
  </div>
</template>

<script>
import Toast from 'vant/lib/toast'
import UploadImage from "./upload_image.vue";
import axios from "axios";
import {Dialog} from "vant";

export default {
  components: {
    UploadImage
  },
  data() {
    return {
      countdown_time: 0,
      ticket_name: '',
      iscos: false,
      proof_img: '',
      orderId: undefined,
      orderData: {},
      cosConfig: {
        tmpSecretKey: undefined,
        tmpSecretId: undefined,
        bucket: undefined,
        region: undefined,
        sessionToken: '',
        domain: '',
      },
      isLocalCurrencyShow: true,
      transferShow: false,
      actions: [{ id:1,name: this.$t('column.transfer_order') }, { id:2,name: this.$t('column.close_order') }],
    }
  },
  created() {
    this.orderId = this.$route.query.order_id
    this.getcosConfig()
    this.get_info()
  },
  methods: {
    onSelect(item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      this.transferShow = false;
      console.log(item);
      if(item.id === 1){
        this.onClickTransfer()
      }else{
        this.onClickCancel()
      }
    },
    shouldShowColor(status){
      switch ( status) {
        case '0':
          return '#FFF0FD'
        case '1':
          return '#FFF7E2'
        case '3':
          return '#F1FFF6'
        default:
          return '#e0e0e0'
      }
    },
    get_info(){
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=payroll_seller&act=payroll_seller_order_info",{
        params:{
          uid: uid,
          token: token,
          order_id: this.orderId
        }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        if(res.data.status ===1){
         this.orderData = res.data.data
         this.countdown_time = res.data.data.countdown_time * 1000
          this.ticket_name = res.data.data.ticket_name
        }else{
          Toast(res.data.error)
        }
      })
    },
    onClickTransfer() {
      // 转让订单
       Dialog.confirm({
        title: this.$t('column.whether_to_transfer_order'),
        confirmButtonColor: '#FF61F5',
        confirmButtonText: this.$t('btn.confirm'),
        cancelButtonText: this.$t('btn.cancel'),
      }).then(() => {
        const toast = this.$toast.loading({
          duration: 0, // 持续展示
          forbidClick: true,
          message: this.$t('other.Loading') + '...',
          className: 'custom-loading-toast' // 添加自定义类名
        });
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=payroll_seller&act=transfer_order",{
          params:{
            uid: uid,
            token: token,
            order_id: this.orderId
          }
        }).then(res =>{
          toast.clear(); // 关闭加载提示
          if(res.data.status ===1){
            Toast({
              message: res.data.error,
              duration: 2000, // 持续2秒
              onClose: () => {
                // 这里写Toast关闭后要执行的方法
                this.onClickLeft()
              }
            })
          }else{
            Toast(res.data.error)
          }
        })
      })
    },
    onClickCancel() {
      Dialog.confirm({
        title: this.$t('column.is_cancel_order'),
        confirmButtonColor: '#FF61F5',
        confirmButtonText: this.$t('btn.confirm'),
        cancelButtonText: this.$t('btn.cancel'),
      }).then(() => {
        const toast = this.$toast.loading({
          duration: 0, // 持续展示
          forbidClick: true,
          message: this.$t('other.Loading') + '...',
          className: 'custom-loading-toast' // 添加自定义类名
        });
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=payroll_seller&act=cancel_payment",{
          params:{
            uid: uid,
            token: token,
            order_id: this.orderId
          }
        }).then(res =>{
          toast.clear(); // 关闭加载提示
          if(res.data.status ===1){
            Toast({
              message: res.data.error,
              duration: 2000, // 持续2秒
              onClose: () => {
                // 这里写Toast关闭后要执行的方法
                this.onClickLeft()
              }
            })
          }else{
            Toast(res.data.error)
          }
        })
      })
    },
    onClickButton() {
      Dialog.confirm({
        title: this.$t('column.sure_payment_has_been_made'),
        confirmButtonColor: '#FF61F5',
        confirmButtonText: this.$t('btn.confirm'),
        cancelButtonText: this.$t('btn.cancel'),
      }).then(() => {
        const toast = this.$toast.loading({
          duration: 0, // 持续展示
          forbidClick: true,
          message: this.$t('other.Loading') + '...',
          className: 'custom-loading-toast' // 添加自定义类名
        });
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=payroll_seller&act=payroll_seller_order_payment",{
          params:{
            uid: uid,
            token: token,
            order_id: this.orderId,
            payment_proofs_img: this.proof_img
          }
        }).then(res =>{
          toast.clear(); // 关闭加载提示
          if(res.data.status ===1){
            Toast({
              message: res.data.error,
              duration: 2000, // 持续2秒
              onClose: () => {
                // 这里写Toast关闭后要执行的方法
                this.onClickLeft()
              }
            })
          }else{
            Toast(res.data.error)
          }
        })
      })
    },
    getcosConfig(){
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=app&act=getCosSTS",{ params:{ uid: uid, token: token }}).then(res =>{
        console.log(res.data)
        if(res.data.status===1){
          this.cosConfig = res.data.data.sts
          this.iscos = true
        }else{
          this.$emit('errorUploadImage', res.data.error)
        }
      })
    },
    handleSuccess(url) {
      // 上传成功
      console.log('====handleSuccess====')
      console.log(url)
      this.proof_img = url
    },
    handleError(err) {
      console.log('====handleError====')
      // 上传失败
      Toast(err);
    },
    copyId(id) {
      const element = document.getElementById(id);
      if (!element) {
        Toast('error');
        return;
      }
      // 创建临时textarea元素用于复制
      const tempTextArea = document.createElement('textarea');
      tempTextArea.value = element.textContent || element.innerText;
      document.body.appendChild(tempTextArea);
      // 选择并复制文本
      tempTextArea.select();
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          Toast(this.$t('column.copy_success'));
          // 添加复制成功效果
          if (this.currentButton) {
            this.currentButton.classList.remove('copied');
          }
          this.currentButton = event.currentTarget;
          this.currentButton.classList.add('copied');
          // 3秒后移除复制成功样式
          setTimeout(() => {
            if (this.currentButton) {
              this.currentButton.classList.remove('copied');
            }
          }, 3000);
        } else {
          Toast('copy error');
        }
      } catch (err) {
        Toast('copy error: ' + err);
      }
      // 移除临时元素
      document.body.removeChild(tempTextArea);
    },
    onClickLeft() {
      this.$router.go(-1)
    }
  }
}
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/components/approve_order.vue